function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage10JobSearchResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 44 44)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 20.01 -19.98)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,90,14)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-64.01, -24.02)",
    d: "M 44.0252 21.3207 L 66.6786 44.0247 L 75.3491 35.3766 L 83.9971 44.0471 L 44.0421 4.0022 L 52.6901 12.6727 L 44.0252 21.3207 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -15.69 19.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(110,232,252)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-28.31, -63.99)",
    d: "M 35.3042 75.3317 L 43.969 66.6837 L 21.3157 43.9741 L 12.6452 52.6278 L 43.9522 84.0022 L 35.3042 75.3317 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -15.65 -20.01)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(106,14,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-28.35, -23.99)",
    d: "M 44.0252 21.3207 L 35.3715 12.6502 L 44.042 4.0022 L 12.6676 35.3092 L 21.3156 43.9741 L 44.0252 21.3207 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.03 -30.51)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,90,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-44.03, -13.49)",
    d: "M 41.2094 6.82551 L 35.3713 12.6514 L 44.0227 21.3208 L 52.6921 12.6695 L 46.8663 6.83144 C 45.3058 5.2677 42.7731 5.26505 41.2094 6.82551 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -30.51 -0.04)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(110,232,252)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-13.49, -43.96)",
    d: "M 12.6695 35.3014 L 6.83139 41.1273 C 5.26766 42.6878 5.265 45.2204 6.82546 46.7841 L 12.6513 52.6222 L 21.3208 43.9709 L 12.6695 35.3014 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 19.97 20.01)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,190,14)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-63.97, -64.01)",
    d: "M 66.6786 44.0247 L 43.9691 66.6837 L 52.6227 75.3542 L 43.9522 84.0022 L 83.9971 44.0471 L 75.3266 52.6952 L 66.6786 44.0247 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 30.5 0.03)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,190,14)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-74.5, -44.03)",
    d: "M 75.3423 35.3714 L 66.6728 44.0227 L 75.3241 52.6922 L 81.1622 46.8663 C 82.7259 45.3058 82.7286 42.7732 81.1681 41.2095 L 75.3423 35.3714 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.04 30.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(71,232,155)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-43.96, -74.5)",
    d: "M 43.9709 66.6729 L 35.3014 75.3242 L 41.1273 81.1623 C 42.6877 82.726 45.2204 82.7287 46.7841 81.1682 L 52.6222 75.3424 L 43.9709 66.6729 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage10JobSearchResult);
export default __webpack_public_path__ + "static/media/image10 JobSearchResult.201f26caec3d8323381f345e1e2901e9.svg";
export { ForwardRef as ReactComponent };